// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/tabbed-content/module';
import './modules/theme/hero-slider/module';
import './modules/theme/about-widget/module';
import './modules/theme/testimonials/module';
import './modules/evox/contact-form/module';
import './modules/evox/brands-widget/module';
import './modules/theme/newsletter/module';
import './modules/theme/projects-gallery/module';
import './modules/theme/video-widget/module';
import './modules/evox/blog-posts/module';
import './modules/theme/hero-static/module';
import './modules/theme/about-us-tabbed/module';
import './modules/theme/projects-gallery-slider/module';
import './modules/theme/content-slider/module';

// layouts

// leave me last
import './js/base/base-end';
